import React, { Component } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Button, Card, Label } from 'semantic-ui-react';
import i18next from 'i18next';

const catTypeColors = { 'mandatory': 'rgba(20, 247, 5, 0.15)', 'addon': '#f7d90554' };

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    paddingTop: 8,

    // change background colour if dragging
    // background: "lightgray",

    // styles we need to apply on draggables
    ...draggableStyle
});

class MenuSubcategory extends Component {
    state = { safeDelete: false }

    handleItemDelete = () => {
        if (this.props.preventSafeDelete || this.state.safeDelete) {
            const { category } = this.props;
            this.props.handleRemove(category.id);
            this.setState({ safeDelete: false });
        } else {
            this.setState({ safeDelete: true });
            setTimeout(() => this.setState({ safeDelete: false }), 2000);
        }
    }

    render() {
        const { category, parantId, index } = this.props;

        return (
            <Draggable draggableId={`subcategory-${category.id}-${parantId}`} index={index}>
                {(provided, snapshot) => (
                    <div
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                    >
                        <Card fluid>
                            {/* <Button floated="right" circular size='mini' icon='write' basic onClick={() => null} /> */}
                            <Card.Content style={{ display: 'flex', alignItems: 'center', padding: 5, background: catTypeColors[category.type] }}>
                                <Label style={{ width: 65, textAlign: 'center' }}>{category.key}</Label>
                                <Card.Header style={{ flex: 1, marginLeft: 4, marginRight: 4 }}>{category.name}</Card.Header>

                                {this.props.handleSubcategoryClick && <Button circular size='mini' icon='search' basic onClick={() => this.props.handleSubcategoryClick(category.id)} />}
                                <Button type="button" circular size='mini' icon='trash' basic negative={this.state.safeDelete} onClick={this.handleItemDelete} />
                            </Card.Content>
                            {/* <Card.Description>
                                    <Label>{category.key}</Label>
                                    <Label color={catTypeColors[category.type]}>{i18next.t(`menu.${category.type}`)}</Label>
                                </Card.Description> */}
                        </Card>
                    </div>
                )}
            </Draggable>
        );
    }
}

export default MenuSubcategory;